import React from 'react';
// Import Shared Utils
import { isHRB } from 'shared-components/src/utils/whitelabel';
// Import Component Styles
import { PhoneLink } from './styles';

// HRB's cardholder support line. Only HRB publishes a number; every other company's
// copy says "contact support" instead.
export const HRB_SUPPORT_PHONE = { display: '1-855-342-6924', dial: '18553426924' };

// Values for the messages that send the cardholder to support: {hrb} picks the wording
// with a select ("call {phone}" for HRB, "contact support" otherwise) and {phone} is the
// call link the HRB wording uses.
const supportContactValues = () => ({
  hrb: isHRB() ? 'yes' : 'no',
  phone: <PhoneLink href={`tel:${HRB_SUPPORT_PHONE.dial}`}>{HRB_SUPPORT_PHONE.display}</PhoneLink>,
});

export default supportContactValues;
